import {view, Icon, Link} from '@sail/ui';
import {support} from '@sail/icons/react/Icon';
import {document, api, list} from '@sail/icons/react/Icon__xsmall';
import {StripeAssistantLiveAnswersSource} from '@stripe-internal/conversations-client';
import {useAnalytics} from '../../AnalyticsProvider';

export const SourceLink = ({
  source,
}: {
  source: StripeAssistantLiveAnswersSource;
}) => {
  const analytics = useAnalytics();

  let text = 'Support';
  let icon = support;
  switch (source.collection) {
    case 'support_topic_pages':
      icon = list;
      text = 'Topic';
      break;
    case 'stripe_docs':
      icon = document;
      text = 'Docs';
      break;
    case 'stripe_api_docs':
      icon = api;
      text = 'API';
      break;
    default:
  }

  return (
    <view.div
      className="uh-article-sources-dropdown"
      css={{
        stack: 'x',
        alignY: 'center',
        alignX: 'start',
        gap: 'small',
      }}
    >
      <Icon
        icon={icon}
        size="xsmall"
        css={{
          color: 'action.primary',
          minWidth: 12,
        }}
      />
      <Link
        href={source.url}
        target={source.url}
        onPress={() => {
          analytics.action(
            'universal_help_live_answers_frontend_sources_link_clicked',
            {
              live_answers_source_url: source.url,
              live_answers_source_title: source.title,
              live_answers_source_collection: source.collection,
              live_answers_source_score: source.score,
            },
          );
        }}
        css={{
          fontFamily: 'label.medium',
          fontSize: 12,
          color: 'text',
          fontWeight: 600,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          ':hover': {
            color: 'text',
          },
        }}
      >
        {text ? (
          <view.span css={{color: 'action.primary'}}>{text}: </view.span>
        ) : null}
        {source.title}
      </Link>
    </view.div>
  );
};
